var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import requestStatusesPlugin from './request-statuses-plugin';
import generateDefaultInitialState from './utils/generate-default-initial-state';
import composeReducers from './utils/compose-reducers';
import warning from './utils/warning';

// Create a resource reducer.
//
// `resourceName`: the plural name of your resource. For instance, "books".
// `options`: pass options to change the behavior of the reducer. See the docs
//   for more information on the available options.
export default function resourceReducer(resourceName) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$plugins = options.plugins,
      plugins = _options$plugins === undefined ? [] : _options$plugins,
      _options$initialState = options.initialState,
      initialState = _options$initialState === undefined ? {} : _options$initialState;

  var defaultInitialState = generateDefaultInitialState();
  var initial = _extends({}, defaultInitialState, initialState);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof resourceName !== 'string') {
      warning('The value of "resourceName" that you passed to resourceReducer was ' + 'not a string. The resource name must be a string. You should check ' + 'your reducer configuration.');
    }
  }

  var allPlugins = plugins.concat(requestStatusesPlugin);

  var computedPlugins = allPlugins.map(function (plugin) {
    var result = plugin(resourceName, options);
    if (process.env.NODE_ENV !== 'production') {
      if (typeof result !== 'function') {
        warning('A plugin was initialized that did not return a function. Plugins ' + 'should return a function with the same signature as a reducer. ' + 'For more, refer to the documentation on plugins: ' + 'https://redux-resource.js.org/docs/guides/plugins.html');
      }
    }
    return result;
  });

  return function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial;
    var action = arguments[1];

    if (process.env.NODE_ENV !== 'production') {
      if (action.request && typeof action.request !== 'string') {
        warning('An invalid request name was included in an action with type ' + ('"' + action.type + '". Request names must be strings.'));
      }

      if (action.list && typeof action.list !== 'string') {
        warning('An invalid list was included in an action with type ' + ('"' + action.type + '". Lists must be strings.'));
      }
    }

    return composeReducers(computedPlugins)(state, action);
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-resource/es/resource-reducer.js
// module id = 1021
// module chunks = 2